<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Revu" />
            <ReVu />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import ReVu from '../Revu/ReVu.vue';


export default {
    name: 'RevuPage',
    components: {
        NavBar,
        PageTitle,
        ReVu,
        FooterComp,
    }
}
</script>